import { Box, Button, Theme, Typography } from "@outschool/backpack";
import { ActivityEnrollableTimesQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import {
  briefDurationTimesString,
  formatDateWithWeekday,
  timeZoneName,
} from "@outschool/time";
import React from "react";

import { PADDING_X_DESKTOP, PADDING_X_MOBILE } from "./AvailableTimeSelector";

export default function ActivityEnrollableTimesFooter({
  selectedDateTime,
  selectedEnrollableTime,
  timeZone,
  hasSelectedTime,
  continueButtonText,
  handleCancelClick,
  handleContinueClick,
  showTeacher,
}: {
  selectedDateTime: Date;
  selectedEnrollableTime?: ActivityEnrollableTimesQuery["activity"]["enrollableTimes"][number];
  timeZone: string;
  hasSelectedTime: boolean;
  continueButtonText: string;
  handleCancelClick: () => void;
  handleContinueClick: () => void;
  showTeacher: boolean;
}) {
  const { t } = useTranslation(
    "ui-components-website\\ClassDetailsPage\\ActivityEnrollableTimesModal"
  );

  return (
    <Box
      flex
      sx={(theme: Theme) => ({
        paddingY: "1em",
        paddingX: PADDING_X_MOBILE,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        boxShadow:
          "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 16px 56px rgba(0, 0, 0, 0.16)",
        [theme.breakpoints.up("md")]: {
          paddingX: PADDING_X_DESKTOP,
        },
      })}
    >
      <Box>
        <Box
          flex
          sx={{
            flexDirection: "row",
            flexWrap: "wrap",
            columnGap: "1em",
          }}
        >
          <Typography variant="body1">
            {formatDateWithWeekday(selectedDateTime, timeZone)}
          </Typography>
          <Typography variant="body1">
            {hasSelectedTime
              ? briefDurationTimesString(
                  selectedDateTime,
                  selectedEnrollableTime?.endTime,
                  timeZone,
                  true
                )
              : timeZoneName(timeZone)}
          </Typography>
        </Box>
        {showTeacher && (
          <Typography variant="body1">
            {selectedEnrollableTime?.teacher?.name}
          </Typography>
        )}
      </Box>
      <Box
        flex
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Button variant="link" onClick={handleCancelClick}>
          {t`Cancel`}
        </Button>
        <Button
          variant="contained"
          sx={{
            marginLeft: "1em",
          }}
          onClick={handleContinueClick}
          disabled={!hasSelectedTime}
        >
          {continueButtonText}
        </Button>
      </Box>
    </Box>
  );
}
